import FeaturedPostModal from './FeaturedPostModal';
import FeaturedPostView from './FeaturedPostView';

export default {
  FeaturedPostModal,
  FeaturedPostView,
};
